import React from "react";
import "./OurOfferings.scss";

const OurOfferings = ({ data, serviceTitle, serviceOverview }) => {
  if (!data || data.length === 0) return null;

  return (
    <section className="our-offerings-section">
      <div className="">
        <div className="section-header text-center">
          <p className="subtitle">{serviceTitle}</p>
          <h2 className="main-header">Our Service Offerings</h2>
          <p className="header-description">{serviceOverview}</p>
        </div>

        <div className="offerings-list">
          {data.map((item, index) => (
            <div key={index} className="offering-card">
              <div className="offering-image">
                <img
                  src={item.image}
                  alt={item.title}
                  className="img-placeholder"
                />
              </div>
              <div className="offering-content">
                <h3 className="offering-title">{item.title}</h3>
                <p className="offering-text">{item.description}</p>
              </div>
              <div
                className={`offering-number ${
                  index % 2 === 0 ? "blue" : "orange"
                }`}
              >
                {(index + 1).toString().padStart(2, "0")}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurOfferings;
